import * as RadixToggle from '@radix-ui/react-toggle'
import { TooltipWrapper } from 'components/TooltipWrapper'
import React from 'react'
import styled from 'styled-components'

const ToggleContainer = styled.div`
  cursor: pointer !important;
  height: 40px;
  width: 40px;
  background-color: ${({ theme }) => theme.forecast.background2_5};
  border-radius: 10px;
  align-items: center !important;
  justify-content: center !important;
  button {
    all: unset;
  }
`
const StyledToggle = styled(RadixToggle.Root)`
  opacity: 0.8 !important;
  display: flex !important;
  position: relative !important;
  height: 100% !important;
  width: 100% !important;
  align-items: center !important;
  justify-content: center !important;
  &:hover {
    opacity: 1 !important;
  }
`

export const HoverableToggle: React.FC<
  RadixToggle.ToggleProps & {
    trigger: React.ReactNode
    content: React.ReactNode | undefined
  }
> = ({ trigger, content, ...props }) => {
  return (
    <ToggleContainer>
      <TooltipWrapper
        side={'right'}
        offset={5}
        label={content}
        style={{ width: '100%', height: '100%' }}>
        <StyledToggle {...props}>{trigger}</StyledToggle>
      </TooltipWrapper>
    </ToggleContainer>
  )
}
